module.exports = __webpack_public_path__ + "img/logo.9900881f.png";